const translations = {
  ko: {
    // HeroSection
    hero: {
      text: "우리의 비전은 안전하고 인간과 공존하는 상호작용형 휴머노이드 로봇을 통해\n일상 속에 자연스럽게 스며들어 인간의 능력을 확장하고,\n세상을 혁신하며 삶을 변화시키는 것입니다",
    },
    // CompanySection
    company: {
      label: "우리는",
      title: "세상을 경험시킵니다",
      subtitle: "우리는 진정한 상호작용형 휴머노이드 로봇을 만듭니다.",
      description: "우리의 로봇은 인간처럼 세상을 물리적으로 경험합니다.",
      feature1Light: "힘을",
      feature1Bold: "감지하고",
      feature2Light: "접촉을",
      feature2Bold: "활용하며",
      feature3Light: "충격에",
      feature3Bold: "적응하는",
      footer:
        "새로운 차원의 물리 지능을 발전시키기 위해\n운동과 의미를 연결해 나갑니다.",
    },
    // FeatureSection
    feature: {
      label: "우리의 로봇은",
      title: "인간 친화적이면서도 고도로 유능합니다.",
      description:
        "우리는 사람과 안전하게 협업는 것은 물론, 다양한 임무 —\n정밀 조작부터 역동적 작업까지 수행하는 고성능·인간 친화적 로봇을 설계합니다.",
      overlayLabels: ["정확한", "유연한", "목적에 부합하는"],
      overlayTop: "우리의 로봇은 단순히 안전하거나 친근한 수준을 넘어,",
      overlayPrefix: "",
      overlayBottom: "존재로서 인간이 이룰 수 있는 한계를 확장합니다.",
    },
    // ContactSection
    contact: {
      label: "위로보틱스는",
      title: "휴머노이드 로봇의\n새로운 패러다임을\n정의합니다.",
      description1:
        "우리는 기존 상용 기술의 한계를 넘어선,\n전혀 새로운 휴머노이드 로봇의 패러다임을 정의합니다.",
      description2:
        "점진적인 개선에 머물지 않고,\n진정한 인간 수준의 능력으로 도약하기 위한\n근본적인 변화를 이끌어갑니다.",
      buttonAllex: "우리의 로봇, ",
      buttonAllexBold: "ALLEX",
      buttonAllexEnd: "를 살펴보세요.",
      buttonCareers: "에 합류하세요.",
    },
    // AllexHero
    allexHero: {
      subtitle: "세상의 모든 경험을 담기 위해 설계된\n범용 휴머노이드 로봇",
      description:
        "ALLEX는 인간 수준의 유연성(Compliance), 기민한 조작성(Dexterity), 그리고 탁월한 역구동성과 안정성을 결합하여\n현실 세계에서 안전하고 능동적으로 상호작용하기 위해 다음과 같은 특징을 갖추고 있습니다:",
      feature1Title: "전신 유연성",
      feature1Desc:
        "팔, 손, 목, 허리 등 전신에 걸쳐\n물리적 충돌과 외력을 흡수하며 자연스럽게 반응합니다.",
      feature2Title: "인간 수준의 조작성",
      feature2Desc:
        "고자유도(High-DOF) 손을 통해\n정밀함, 유연성, 강도를 모두 갖춘 인간 수준의 조작 능력을 구현합니다.",
      feature3Title: "탁월한 역구동성",
      feature3Desc:
        "낮은 말단 질량, 낮은 마찰과 관성으로\n시뮬레이션과 실제 간의 격차(sim-to-real gap)를 최소화합니다.",
      feature4Title: "실환경 대응 성능",
      feature4Desc:
        "섬세한 조작부터 고하중 및 고충격 작업까지\n현실 세계의 다양한 작업을 수행할 수 있도록 정밀하게 설계되었습니다.",
    },
    // AllexFeature
    allexFeature: {
      label1: "핵심기능 | 01",
      title1: ["고자유도 순응형", "로봇 핸드"],
      highlight1: "손끝 반복정밀도≤0.5mm, 손끝 최대 힘≥40N, 한 손 Lifting 최대 중량>30kg",
      desc1: [
        "15자유도(DoF), 인간 손 크기 기반의 설계",
        "100gf 수준의 미세한 힘 감지",
        "고정밀, 고강도 제어",
      ],
      label2: "핵심기능 | 02",
      title2: ["혁신적 Actuator", "설계 기술"],
      highlight2: "상용 Actuator 대비 마찰 1/10, 회전관성 1/24 수준",
      desc2: [
        "혁신적 Actuator 설계",
        "고역구동성 및 뛰어난 반응성",
        "초저마찰, 저관성 구동기",
      ],
      label3: "핵심기능 | 03",
      title3: ["경량 구조 및", "고하중 설계"],
      highlight3:
        "핸드 포함한 한 팔의 무게 약 9kg",
      desc3: [
        "경량 설계와 말단부 무게 최소화",
        "고하중 핸들링",
        "인간 수준의 안정적이고 민첩한 모션",
      ],
      label4: "핵심기능 | 04",
      title4: ["전신 힘", "제어 및 상호작용"],
      highlight4:
        "전신 중력보상 메커니즘 적용",
      desc4: [
        "안전한 힘 기반의 상호작용",
        "Sim-to-Real 격차의 최소화",
      ],
      label5: "핵심기능 | 05",
      title5: ["고속", "통신 및 제어"],
      highlight5: "20kHz 실시간 제어 및 고속 통신",
      desc5: [
        "고속 EtherCAT 네트워크",
        "20 kHz 토크 제어 루프",
        "인간 수준의 적응성",
      ],
    },
    careerDetails: {
      mechanicalDesign: {
        title: "로봇 설계 엔지니어",
        type: "정규직",
        location: "서울 강남",
        openings: "충원 시 마감",
        sections: [
          {
            title: "포지션 개요",
            content:
              "휴머노이드 로봇의 상·하체, 고자유도 로봇 핸드, 모바일 플랫폼, 리더 시스템을 포함한 프로토타입 및 양산 제품의 전체 기구 설계를 담당합니다. 이 포지션은 경량·고강성 구조물과 정밀 구동계(감속기, 텐던, 케이블, 정밀 기어 등)를 직접 설계하며, 로봇의 성능, 신뢰성, 생산성을 종합적으로 최적화하는 핵심 역할을 수행합니다.",
          },
          {
            title: "주요 업무",
            list: [
              "휴머노이드 로봇 ALLEX의 프로토타입 및 양산 설계",
              "상·하체, 팔, 손, 목, 허리를 포함한 고자유도 메커니즘 및 구동기 설계",
              "DFMA(Design for Manufacturing and Assembly) 기반 제조·조립 공정 최적화",
              "3D CAD 설계 및 해석 (SolidWorks, CATIA, NX 등)",
              "도면·BOM·기술 문서 작성 및 협력업체 커뮤니케이션",
              "프로토타입 제작, 조립, 테스트 및 품질 개선",
            ],
          },
          {
            title: "자격요건",
            list: [
              "기계, 메카트로닉스, 로봇공학 등 관련 전공 학사 이상",
              "구조해석(FEA), 재질 선정, 공차 설계 경험",
              "3D CAD 활용 능숙",
              "실무경험 3년 이상 (학위과정포함)",
            ],
          },
          {
            title: "우대사항",
            list: [
              "협동로봇·산업용 매니퓰레이터 양산 설계 유경험자 또는 고자유도 로봇핸드 및 휴머노이드 연구개발 유경험자",
            ],
          },
          {
            title: "지원 방법",
            content:
              "이메일: recruite@wirobotics.com\n제출서류: 이력서, 포트폴리오(선택)\n마감일: 채용시까지",
          },
        ],
      },
      electronicsHardware: {
        title: "전장 하드웨어 엔지니어",
        type: "정규직",
        location: "서울 강남",
        openings: "충원 시 마감",
        sections: [
          {
            title: "포지션 개요",
            content:
              "휴머노이드 로봇을 포함한 전체 시스템의 전장 하드웨어를 설계·양산화합니다. 고속 통신·고신뢰 전력 시스템을 포함한 제어기, 서보 드라이버, 센서 보드 등 핵심 전자 시스템을 직접 개발합니다.",
          },
          {
            title: "주요 업무",
            list: [
              "메인보드·서보드라이버·센서보드 회로 설계 및 제작",
              "EtherCAT, CAN, RS485 등 고속 통신 설계",
              "전력분배, 보호회로, EMI/EMC 대응",
              "하네스·커넥터·배선 설계 및 양산 관리",
              "회로 시험·인증(CE, KC 등) 및 신뢰성 검증",
              "부품 수급 및 협력사 관리",
            ],
          },
          {
            title: "자격요건",
            list: [
              "전기·전자·메카트로닉스 관련 전공 학사 이상",
              "고전류·고속 신호 PCB 설계 경력",
              "Altium Designer, OrCAD, KiCad 등 활용 능숙",
              "전력변환 및 보호회로 설계 경험",
              "로봇/자동화 장비 전장 설계 경험",
            ],
          },
          {
            title: "우대사항",
            list: [
              "BLDC 서보·정밀 모터 제어 하드웨어 설계 경험",
              "EMC/EMI 인증, UL/CE/KC/Functional Safety 등 안전규격 대응 경험",
              "구동 하네스 설계 및 제조 경험",
            ],
          },
          {
            title: "지원 방법",
            content:
              "이메일: recruite@wirobotics.com\n제출서류: 이력서, 포트폴리오 (선택)\n마감일: 채용시까지",
          },
        ],
      },
      robotSoftware: {
        title: "로봇 소프트웨어 엔지니어",
        type: "정규직",
        location: "서울 강남",
        openings: "충원 시 마감",
        sections: [
          {
            title: "포지션 개요",
            content:
              "초 고자유도 휴머노이드 로봇의 실시간 제어 및 데이터 인프라 소프트웨어를 개발합니다. Linux 실시간 OS와 ROS2 기반으로 모듈형 제어 시스템, 멀티스레드 로직, 데이터 스트리밍, 실시간 제어 및 시뮬레이션 환경을 구축합니다.",
          },
          {
            title: "주요 업무",
            list: [
              "실시간 Linux기반 Middleware 구축 및 ROS2/DDS 기반 제어 및 운영 소프트웨어 개발",
              "실시간 로깅·모니터링·시각화·업데이트 시스템 구축",
              "센서 데이터 스트리밍, 데이터 로깅, 전처리 자동화",
              "Gazebo/Isaac Sim 기반 시뮬레이션 및 CI 통합 테스트",
              "제어·AI·하드웨어 팀과 협업",
            ],
          },
          {
            title: "자격요건",
            list: [
              "Python/C++ 기반 대규모 시스템 개발 경험",
              "Realtime Linux, 멀티스레드, 네트워크 프로그래밍 이해",
              "Git, Docker, CI/CD 활용 능력로봇/자동화 장비 전장 설계 경험",
            ],
          },
          {
            title: "우대사항",
            list: [
              "ROS2, RTOS, DDS, Xenomai 등 실시간 프레임워크 경험",
              "로봇·자율주행 소프트웨어 개발 경력",
              "고성능 최적화(C++/Rust) 경험",
            ],
          },
          {
            title: "지원 방법",
            content:
              "이메일: recruite@wirobotics.com\n제출서류: 이력서, 포트폴리오 (선택)\n마감일: 채용시까지",
          },
        ],
      },
      robotAIEngineer1: {
        title: "AI 엔지니어 (Robot Learning)",
        type: "정규직",
        location: "서울 강남",
        openings: "충원 시 마감",
        sections: [
          {
            title: "포지션 개요",
            content:
              "WIRobotics는 완전히 새로운 패러다임의 로봇 시스템과 인터렉션을 깊이 이해하는 AI를 기반으로, 현재 로봇의 한계를 넘어 인간 수준의 지능과 조작능력, 행동능력을 가진 로봇 개발을 목표로 합니다. ACT, Diffusion Policy, VLA 등 최신 로봇 학습 기반 모델을 실제 로봇에 적용하여, 인간 수준의 고난이도 작업을 수행할 수 있는 Physical Intelligence를 함께 구현할 AI 엔지니어를 모집합니다.",
          },
          {
            title: "주요업무",
            list: [
              "AI 엔지니어 (Robot Learning / Generative Policy / VLA)",
              {
                text: "ACT, Diffusion Policy, VLA(Visual-Language-Action) 등 최신 로봇 학습 기반 모델을 실제 로봇에 적용하고 성능 개선. 실제 환경에서 모델을 학습, 배포, 디버깅하는 end-to-end 시스템 작업 수행.",
                subList: [
                  "ACT, Diffusion Policy, Transformer 기반 로봇 정책 모델 적용 및 학습",
                  "VLA 기반 행동 정책 적용 및 운영",
                  "모방 학습(Imitation Learning) 및 강화 학습(Reinforcement Learning)을 통한 제어 정책 학습",
                  "DAgger, Behavior Cloning, Policy Gradient 등의 알고리즘 적용",
                  "로봇 데이터 수집 파이프라인 설계 및 데이터 정제/증강",
                  "시뮬레이션과 실제 로봇 간 안정적인 학습·검증 파이프라인 구축",
                ],
              },
            ],
          },
          {
            title: "지원 자격",
            list: [
              "머신러닝 및 딥러닝 모델에 대한 높은 이해 (Transformer, Diffusion, ACT, VLA 등)",
              "Behavior Cloning, DAgger, Policy Gradient 등 IL/RL 알고리즘 이해 및 구현 경험",
              "Python / C++ 기반 모델 개발 및 최적화 경험",
              "학습된 모델을 실제 로봇 제어 시스템에 적용해본 경험",
            ],
          },
          {
            title: "우대 사항",
            list: [
              "Robotics / Machine Learning / Control 전공 또는 관련 석·박사 우대",
              "IsaacSim, MuJoCo, RLBench, RT-X 등 로봇 학습 생태계 경험",
              "Multimodal policy기반 VLA action space 활용 및 튜닝 경험",
            ],
          },
          {
            title: "지원 방법",
            content:
              "이메일: recruite@wirobotics.com\n제출서류: 이력서, 포트폴리오 (선택)\n마감일: 채용시까지",
          },
        ],
      },
      robotAIEngineer2: {
        title: "AI 엔지니어 (Inference System)",
        type: "정규직",
        location: "서울 강남",
        openings: "충원 시 마감",
        sections: [
          {
            title: "포지션 개요",
            content:
              "WIRobotics는 로봇이 스스로 이해하고, 학습하며, 행동할 수 있는 지능을 구축하고 있습니다. 시각·언어·행동 데이터를 통합한 대규모 로봇 AI 모델(Robot Foundation Model) 을 개발하여, 휴머노이드 로봇이 실제 세계에서 물리적으로 상호작용하고 스스로 학습할 수 있는 Physical Intelligence를 구현합니다.",
          },
          {
            title: "주요업무",
            list: [
              "AI 엔지니어 (Inference System / Runtime Optimization / Deployment)",
              {
                text: "시스템 엔지니어링·성능 최적화·배포 경험을 기반으로 실시간 로봇 inference pipeline을 설계하고 최적화 수행. 실시간 inference pipeline을 구축",
                subList: [
                  "실시간 로봇 inference pipeline 아키텍처 설계 및 구축",
                  "TensorRT, ONNX Runtime, CUDA 기반 모델 변환 및 최적화",
                  "Quantization, Pruning, mixed precision 등 latency·memory 개선",
                  "Profiling 기반 성능 분석 및 시스템 디버깅",
                  "Edge/embedded 환경에서의 deployment 및 운영 안정화",
                  "ML/로봇 시스템 팀과 협업하여 모델-시스템 통합 성능 최적화",
                ],
              },
            ],
          },
          {
            title: "지원 자격",
            list: [
              "Python / C++ 기반 소프트웨어 개발 및 최적화 경험",
              "GPU/NPU 기반 모델 inference 최적화 경험 (TensorRT, ONNX Runtime, CUDA 등)",
              "모델 경량화, 효율화, 배포 경험 (quantization, pruning, TensorRT/ONNX 변환 등)",
              "시스템 구조 설계 및 성능 병목 분석 경험 (inference pipeline profiling, latency/memory optimization 등)",
            ],
          },
          {
            title: "우대 사항",
            list: [
              "Senior/Staff 수준의 시스템 엔지니어링 경험",
              "ROS/ROS2, embedded system, 실시간 시스템 경험",
              "Robotics inference 적용 경험 (선택사항. 필수 아님)",
            ],
          },
          {
            title: "지원 방법",
            content:
              "이메일: recruite@wirobotics.com\n제출서류: 이력서, 포트폴리오 (선택)\n마감일: 채용시까지",
          },
        ],
      },
      robotControl: {
        title: "로봇 제어 엔지니어",
        type: "정규직",
        location: "서울 강남",
        openings: "충원 시 마감",
        sections: [
          {
            title: "포지션 개요",
            content:
              "휴머노이드 로봇 ALLEX의 전신 제어 시스템을 설계하고 구현합니다. 고자유도 팔·손뿐 아니라 모바일 플랫폼과 이족보행, 상체를 포함한 전신 동역학 기반 제어를 수행하며, 운동학/동역학 해석부터 실시간 제어기 구현, 실기 검증, 양산 신뢰성 확보까지 전 과정을 주도합니다. 또한, 리더–팔로워 시스템 간 리타게팅(Retargeting) 및 샘플링 비동기 환경에서의 정밀 모션 동기화 제어를 포함한 원격 제어(teleoperation) 및 상호작용 시스템을 개발합니다.",
          },
          {
            title: "주요 업무",
            list: [
              {
                text: "운동학·동역학 기반 제어 알고리즘 개발",
                subList: [
                  "기구학 모델링, Redundancy 포함 최적 제어 설계",
                  "마찰모델, Nonlinearity 및 Dynamics 모델링 및 실시간 제어기 구현",
                ],
              },
              {
                text: "로봇 전신 통합 제어 (Full-Body Control)",
                subList: [
                  "상체·하체·이족보행·모바일 플랫폼을 포함한 통합 모션 제어",
                  "고자유도 손(Hand) 및 다중 서브시스템 간 협조 제어",
                  "물리적 상호작용 및 안전 제어 로직 설계",
                  "임피던스/어드미턴스 제어, 접촉 기반 상호작용 제어",
                ],
              },
              {
                text: "실시간 제어 인프라 개발",
                subList: [
                  "실시간 경로 계획 등 모션 플래닝 Library 구축",
                  "원격제어(teleoperation) 알고리즘 개발",
                  "리더–팔로워 시스템 간 모션 정밀도 유지 및 비동기 샘플링 보정",
                ],
              },
            ],
          },
          {
            title: "자격요건",
            list: [
              "로봇공학, 제어공학, 메카트로닉스 석사 이상",
              "C/C++, ROS2, RTOS 실시간 제어 구현 경험",
              "고자유도 로봇 제어 및 센서 융합 경험",
            ],
          },
          {
            title: "우대사항",
            list: [
              "휴머노이드 제어 실무 경험",
              "EtherCAT 기반 고속 제어 및 안전 제어 경험",
              "고정밀 시뮬레이션 환경 구축 능력",
            ],
          },
          {
            title: "지원 방법",
            content:
              "이메일: recruite@wirobotics.com\n제출서류: 이력서, 포트폴리오 (선택)\n마감일: 채용시까지",
          },
        ],
      },
      firmware: {
        title: "로봇 통신 및 펌웨어 엔지니어",
        type: "정규직",
        location: "서울 강남",
        openings: "충원 시 마감",
        sections: [
          {
            title: "포지션 개요",
            content:
              "휴머노이드 로봇 ALLEX의 실시간 통신·임베디드 펌웨어·기능안전 시스템(FS) 을 통합적으로 설계하고 있습니다. 이 포지션은 EtherCAT 기반 네트워크 및 안전 아키텍처의 핵심을 담당하며, 가정·산업 환경에서 안전하게 동작할 수 있는 휴머노이드 로봇의 안전 인프라를 구축합니다.",
          },
          {
            title: "주요 업무",
            list: [
              "실시간 통신 및 펌웨어 아키텍처 설계",
              "EtherCAT, CAN, RS485, SPI 기반의 통신 구조 설계 및 최적화",
              "분산 클럭, 동기화, 실시간 데이터 스트리밍 로직 개발",
              "로봇 제어보드·센서·서보드라이버용 임베디드 펌웨어(C/C++) 구현",
              "기능안전(Functional Safety) 설계 및 인증 대응",
              "IEC 61508, ISO 13849, ISO 10218 등 국제 안전규격 기반 로직 설계",
              "안전 분석(FMEA/FMEDA), 위험도 평가, Safety Plan 및 안전 문서화",
              "인증기관 및 외부 평가기관과의 협업을 통한 제품 안전인증 추진",
              "시스템 통합 및 검증",
              "안전 로직과 제어 시스템 간 인터페이스 검증",
              "시뮬레이션 및 실로봇 테스트 기반 안전 기능 검증",
              "설계·제어·AI팀과 협력하여 Safety-Critical 시스템 통합",
            ],
          },
          {
            title: "자격요건",
            list: [
              "전자공학, 제어공학, 로봇공학 등 관련 전공 학사 이상",
              "C/C++ 기반 임베디드 펌웨어 및 RTOS 환경 개발 경험",
              "EtherCAT, CANopen, RS485, SPI 등 산업용 Fieldbus 실무 경험",
              "Functional Safety 표준(ISO 61508, ISO 13849, ISO 10218 등)에 대한 이해 및 적용 경험",
              "하드웨어·펌웨어 연계 디버깅 및 시스템 통합 능력",
            ],
          },
          {
            title: "우대사항",
            list: [
              "로봇·산업 자동화 장비의 실시간 통신 및 Safety 아키텍처 설계 경험",
              "국제 안전 인증 대응(UL, CE, KC, NRTL, Functional Safety 등) 및 문서 작성 경험",
              "리눅스 실시간 커널(Xenomai / Preempt-RT) 경험",
              "안전 관련 요구사항(ASIL, SIL 등)에 기반한 위험도 평가 경험",
              "EtherCAT Safety (FSoE) 통신 구현 경험",
            ],
          },
          {
            title: "지원 방법",
            content:
              "이메일: recruite@wirobotics.com\n제출서류: 이력서, 포트폴리오 (선택)\n마감일: 채용시까지",
          },
        ],
      },
    },
    careers: {
      title: "로보틱스를 다시 정의하며, 한계를 넘어, 세상을 바꾸는 여정",
      titleAcc: "그 여정에 함께할 당신을 찾고 있습니다.",
      description1:
        "로보틱스와 AI — 오랫동안 나란히 진화해온 두 축이 이제 하나로 맞물리며, 혁신의 '빅뱅'을 일으키고 있습니다.",
      description2:
        "우리의 비전은 원대하고, 미션은 담대하며, 우리가 가진 기술의 잠재력은 한계가 없습니다. 우리는 단순히 '직원'을 찾지 않습니다.",
      description3:
        "상상을 현실로 바꾸는 사람들 — 꿈을 이루는 데 목마른 Builders, 늘 창조적 생각을 하는 사상가, 몽상으로 그치지 않고 실행하는 실천적 인재를 찾습니다.",
      description4:
        "기구 설계(Mechanical Design), 전장(Electronics), 제어(Control), 소프트웨어(Software), AI —\n이 모든 영역에서 함께 로보틱스의 다음 시대를 만들어갈 당신을 기다립니다.",
      positions: {
        mechanicalDesign: "로봇 설계 엔지니어",
        electronicsHardware: "전장 하드웨어 엔지니어",
        robotSoftware: "로봇 소프트웨어 엔지니어",
        robotAIEngineer1: "AI 엔지니어 (Robot Learning)",
        robotAIEngineer2: "AI 엔지니어 (Inference System)",
        robotControl: "로봇 제어 엔지니어",
        firmware: "로봇 통신 및 펌웨어 엔지니어",
      },
      contactTitle: "다른 역할로 기여할 수 있다고 생각하시나요?",
      contactSubtitle: "자유롭게 연락주세요.",
    },
  },
  en: {
    // HeroSection
    hero: {
      text: "Our vision is to revolutionize the world and transform lives by\nbuilding safe, human-coexistent, interactive robots that\nseamlessly integrate into daily life and enhance human capabilities",
    },
    // CompanySection
    company: {
      label: "WE CREATE",
      title: "the next generation of\ntruly interactive humanoid robots",
      subtitle:
        "capable of sensing force, leveraging contact, and adapting to impact.",
      description:
        "Our robots physically experience the world in human-like ways,\ndeveloping a new dimension of Physical Intelligence that connects motion with meaning.",
      feature1Light: "Sensing",
      feature1Bold: "force",
      feature2Light: "Leveraging",
      feature2Bold: "contact",
      feature3Light: "Adapting",
      feature3Bold: "to impact",
      footer:
        "developing a new dimension of physical Intelligence that\nconnects motion with meaning.",
    },
    // FeatureSection
    feature: {
      label: "WE DESIGN",
      title: "human-friendly yet highly capable robots",
      description:
        "that safely collaborate with people and perform diverse tasks — \nfrom precise manipulation and gentle interaction to dynamic, demanding operations.",
      overlayLabels: ["Dexterity", "Flexible", "Purpose-Driven"],
      overlayTop:
        "Our robots go far beyond being simply safe or friendly —",
      overlayPrefix: "they embody ",
      overlayBottom: "expanding what humans can achieve.",
    },
    // ContactSection
    contact: {
      label: "WE DEFINE",
      title: "a new paradigm of\nhumanoid robots",
      description1:
        "that was never possible with \noff-the-shelf technologies.",
      description2:
        "Our approach breaks away from incremental improvement,\nmarking a fundamental leap toward \ntruly human-like capability.",
      buttonAllex: "Look around our robot, ",
      buttonAllexBold: "ALLEX",
      buttonAllexEnd: "",
      buttonCareers: "Join our team,",
    },
    // AllexHero
    allexHero: {
      subtitle:
        "is a general-purpose humanoid robot designed to\ncapture ALL EXperiences from the world.",
      description:
        "It combines whole-body compliance, human-like dexterity, and exceptional robustness to\ninteract, adapt, and perform safely in real-world environments:",
      feature1Title: "Inherent whole-body compliance",
      feature1Desc: "across the arms, hands, neck, and waist",
      feature2Title: "Human-level dexterity through high-DOF hands",
      feature2Desc:
        "that combine precision, compliance, and strength",
      feature3Title: "Extremely high backdrivability and low distal mass",
      feature3Desc: "minimizing the sim-to-real gap",
      feature4Title: "Engineered for real-world performance,",
      feature4Desc:
        "from delicate manipulation to heavy-duty and high-impact tasks",
    },
    // AllexFeature
    allexFeature: {
      label1: "FEATURE | 01",
      title1: ["High-DOF Compliant", "Robotic Hand"],
      highlight1: "Fingertip repeatability ≤0.5mm, Max. fingertip force≥40N, Lifting weight per hand>30kg",
      desc1: [
        "115DOF, compact design with human-hand-seized form factor",
        "Sensorless force detection at approx. 100gf ",
        "High-precision position and compliant control",
      ],
      label2: "FEATURE | 02",
      title2: ["Innovative Actuator", "Design"],
      highlight2:
        "~1/10 friction, 1/24 inertia compared to commercial actuators",
      desc2: [
        "Custom ultra-low-friction low-inertia Actuators",
        "High backdrivability & responsive dynamics",
        "Unified motor control algorithm ",
      ],
      label3: "FEATURE | 03",
      title3: ["Lightweight Structure with", "High Payload Capacity"],
      highlight3: "Approx. 9kg total arm weight including the hand",
      desc3: [
        "Light weight design with low distal mass",
        "High-load handling capacity",
        "Dexterous and agile, human-level motion",
      ],
      label4: "FEATURE | 04",
      title4: ["Whole-Body Force and", "Interaction Control"],
      highlight4: "Whole-body gravity compensation mechanism",
      desc4: [
        "Safe force-based interaction",
        "Minimized sim-to-real gap",
      ],
      label5: "FEATURE | 05",
      title5: ["High-Speed", "Communication and Control"],
      highlight5: "20kHz real-time control & high-speed comms",
      desc5: [
        "High-speed EtherCAT communication",
        "20 kHz torque control loop",
        "Human-level adaptability",
      ],
    },
    careerDetails: {
      mechanicalDesign: {
        title: "Robot Mechanical Design & Manufacturing Engineer",
        type: "Full-Time",
        location: "Seoul",
        openings: "Until filled",
        sections: [
          {
            title: "Overview",
            content:
              "You will be responsible for the prototype and mass-production design of humanoid robots, including upper/lower body, high-DOF robot hands, mobile platforms, and leader systems. This role involves the design of lightweight, high-stiffness structures and precision actuation systems (e.g., reducers, tendons, cables, precision gears), playing a key role in optimizing performance, reliability, and manufacturability.",
          },
          {
            title: "Key Responsibilities",
            list: [
              "Mechanical design for humanoid robot ALLEX, from prototype to mass production",
              "High-DOF mechanism and actuator design (arms, hands, neck, waist, upper/lower body)",
              "DFMA-based process and assembly optimization",
              "3D CAD design and analysis (SolidWorks, CATIA, NX, etc.)",
              "Drawing, BOM, and documentation management with manufacturing partners",
              "Prototype fabrication, assembly, testing, and quality improvement",
            ],
          },
          {
            title: "Qualifications",
            list: [
              "Bachelor’s degree or higher in Mechanical, Mechatronics, or Robotics related Engineering",
              "Experience in FEA, material selection, and tolerance design",
              "Strong proficiency with 3D CAD tools",
              "3+ years of hands-on industry experience (including graduate research experience)",
            ],
          },
          {
            title: "Preferred Qualifications",
            list: [
              "Experience in mass production of collaborative robots or industrial manipulators",
              "OR experience in high-DOF robotic hands or humanoid robot R&D",
            ],
          },
          {
            title: "How to Apply",
            content:
              "Email: recruite@wirobotics.com\nDocuments: Resume, Portfolio (optional)\nDeadline: Open until filled",
          },
        ],
      },
      electronicsHardware: {
        title: "Electrical Hardware Engineer",
        type: "Full-Time",
        location: "Seoul",
        openings: "Until filled",
        sections: [
          {
            title: "Overview",
            content:
              "You will develop and industrialize electrical hardware for humanoid and other robotic systems, including high-speed communication and reliable power electronics. This includes the design and implementation of controllers, servo drivers, and sensor boards that form the core electronic systems of humanoid robots.",
          },
          {
            title: "Key Responsibilities",
            list: [
              "Design and production of main control boards, servo drivers, and sensor boards",
              "High-speed communication interface design (EtherCAT, CAN, RS485, I2C, BiSS)",
              "Power distribution, protection circuits, and EMI/EMC mitigation",
              "Harness, connector, and cabling design for reliability and manufacturability",
              "Circuit testing, validation, and certification (CE, KC, etc.)",
              "Component sourcing and supplier communication",
            ],
          },
          {
            title: "Qualifications",
            list: [
              "Bachelor’s degree or higher in Electrical, Electronics, or Mechatronics Engineering",
              "Professional experience in high-current, high-speed PCB design",
              "Proficiency in Altium Designer, OrCAD, or KiCad",
              "Experience in power conversion and protection circuit design",
              "Hands-on experience with robotics or automation systems",
            ],
          },
          {
            title: "Preferred Qualifications",
            list: [
              "BLDC servo and precision motor control hardware experience",
              "Experience with EMC/EMI certification and compliance (UL/CE/KC/Functional Safety)",
              "Experience in harness design and production",
            ],
          },
          {
            title: "How to Apply",
            content:
              "Email: recruite@wirobotics.com\nDocuments: Resume, Portfolio (optional)\nDeadline: Open until filled",
          },
        ],
      },
      robotSoftware: {
        title: "Software Engineer",
        type: "Full-Time",
        location: "Seoul",
        openings: "Until filled",
        sections: [
          {
            title: "Overview",
            content:
              "Develop the real-time control and data infrastructure software for ultra high-DOF humanoid robots. Build modular control systems, multi-threaded logic, data streaming, and simulation environments based on real-time Linux and ROS2.",
          },
          {
            title: "Key Responsibilities",
            list: [
              "Develop middleware and control/operation software based on ROS2 and DDS",
              "Implement real-time logging, monitoring, visualization, and OTA update systems",
              "Automate sensor data streaming, storage, and preprocessing pipelines",
              "Integrate Gazebo/Isaac Sim environments and implement continuous integration testing",
              "Collaborate closely with control, AI, and hardware engineers",
            ],
          },
          {
            title: "Qualifications",
            list: [
              "Experience developing large-scale software in Python/C++",
              "Strong understanding of real-time Linux, multithreading, and network programming",
              "Familiarity with Git, Docker, and CI/CD workflows",
            ],
          },
          {
            title: "Preferred Qualifications",
            list: [
              "Experience with ROS2, RTOS, DDS, Xenomai, or similar frameworks",
              "Background in robotics, autonomous systems, or industrial software",
              "Performance optimization experience in C++",
            ],
          },
          {
            title: "How to Apply",
            content:
              "Email: recruite@wirobotics.com\nDocuments: Resume, Portfolio (optional)\nDeadline: Open until filled",
          },
        ],
      },
      robotAIEngineer1: {
        title: "AI Engineer (Robot Learning)",
        type: "Full-Time",
        location: "Seoul",
        openings: "Until filled",
        sections: [
          {
            title: "Overview",
            content:
              "At WIRobotics, we develop a new paradigm of robotic systems by combining deep understanding of physical interaction with AI-driven intelligence. We build large-scale robotic AI models that integrate vision, language, and action, enabling humanoid robots to physically interact with the real world and learn from experience. Our goal is to realize Physical Intelligence—robots with human-level intelligence, manipulation, and adaptive behavior beyond the limits of conventional robotics.Key Responsibilities.",
          },
          {
            title: "Key Responsibilities",
            list: [
              {
                text: "Apply state-of-the-art robot learning models such as ACT, Diffusion Policy, and VLA (Vision-Language-Action) to real robotic systems and continuously improve their performance. Work on end-to-end systems, including training, deployment, and debugging of models in real-world environments.",
                subList: [
                  "Apply and train ACT, Diffusion Policy, and Transformer-based robot policy models",
                  "Implement and operate VLA-based action policies",
                  "Train control policies using Imitation Learning and Reinforcement Learning",
                  "Apply algorithms such as DAgger, Behavior Cloning, and Policy Gradient methods",
                  "Design robot data collection pipelines and perform data curation, cleaning, and augmentation",
                  "Build robust training and validation pipelines across simulation and real robots",
                ],
              },
            ],
          },
          {
            title: "Qualifications",
            list: [
              "Strong understanding of machine learning and deep learning models, including Transformers, Diffusion models, ACT, and VLA",
              "Solid understanding and hands-on experience with Imitation Learning (IL) and Reinforcement Learning (RL) algorithms such as Behavior Cloning, DAgger, and Policy Gradient methods",
              "Experience in model development and optimization using Python and C++",
              "Experience deploying trained models to real robot control systems",
            ],
          },
          {
            title: "Preferred Qualifications",
            list: [
              "Advanced degree (Master’s or Ph.D.) in Robotics, Machine Learning, Control, or a related field",
              "Experience with robot learning simulators and benchmarks such as Isaac Sim, MuJoCo, RLBench, and RT-X",
              "Experience utilizing and tuning VLA action spaces based on multimodal policy architectures",
            ],
          },
          {
            title: "How to Apply",
            content:
              "Email: recruite@wirobotics.com\nDocuments: Resume, Portfolio (optional)\nDeadline: Open until filled",
          },
        ],
      },
      robotAIEngineer2: {
        title: "AI Engineer (Inference System)",
        type: "Full-Time",
        location: "Seoul",
        openings: "Until filled",
        sections: [
          {
            title: "Overview",
            content:
              "At WIRobotics, we develop a new paradigm of robotic systems by combining deep understanding of physical interaction with AI-driven intelligence. We build large-scale robotic AI models that integrate vision, language, and action, enabling humanoid robots to physically interact with the real world and learn from experience. Our goal is to realize Physical Intelligence—robots with human-level intelligence, manipulation, and adaptive behavior beyond the limits of conventional robotics.",
          },
          {
            title: "Key Responsibilities",
            list: [
              {
                text: "Design and optimize real-time robot inference pipelines based on system engineering, performance optimization, and deployment experience. Build and operate robust real-time inference pipelines for robotic systems.",
                subList: [
                  "Design and implement real-time robot inference pipeline architectures",
                  "Convert and optimize models using TensorRT, ONNX Runtime, and CUDA",
                  "Improve latency and memory efficiency through quantization, pruning, and mixed-precision techniques",
                  "Perform profiling-based performance analysis and system debugging",
                  "Stabilize deployment and operations in edge/embedded environments",
                  "Collaborate with ML and robotics system teams to optimize end-to-end model–system integration and performance",
                ],
              },
            ],
          },
          {
            title: "Qualifications",
            list: [
              "Experience in software development and optimization using Python and C++",
              "Hands-on experience with GPU/NPU-based model inference optimization, including TensorRT, ONNX Runtime, and CUDA",
              "Experience in model compression, efficiency optimization, and deployment, such as quantization, pruning, and TensorRT/ONNX conversion",
              "Experience in system architecture design and performance bottleneck analysis, including inference pipeline profiling and latency/memory optimization",
            ],
          },
          {
            title: "Preferred Qualifications",
            list: [
              "Senior/Staff-level experience in system engineering",
              "Experience with ROS/ROS2, embedded systems, and real-time systems",
              "Experience applying robotics inference in real-world systems (preferred but not required)",
            ],
          },
          {
            title: "How to Apply",
            content:
              "Email: recruite@wirobotics.com\nDocuments: Resume, Portfolio (optional)\nDeadline: Open until filled",
          },
        ],
      },
      robotControl: {
        title: "Robot Control Engineer",
        type: "Full-Time",
        location: "Seoul",
        openings: "Until filled",
        sections: [
          {
            title: "Overview",
            content:
              "Design and implement the full-body control system for humanoid robot ALLEX. This includes precise real-time control for high-DOF arms and hands, as well as integrated control for mobile platforms, biped locomotion, and upper body motion. You will also develop retargeting and teleoperation systems that enable motion synchronization and precision control between leader–follower robots with different kinematic structures and sampling rates.",
          },
          {
            title: "Key Responsibilities",
            list: [
              {
                text: "Development of control algorithms based on kinematics and dynamics",
                subList: [
                  "Mechanical modeling and optimal control design, including redundancy handling",
                  "Modeling of friction, nonlinearities, and system dynamics, and implementation of real-time controllers",
                ],
              },
              {
                text: "Whole-body control for robotic systems",
                subList: [
                  "Integrated motion control covering upper body, lower body, bipedal locomotion, and mobile platforms",
                  "Coordination control across high-DOF hands and multiple subsystems",
                  "Design of control logic for physical interaction and safety",
                  "Impedance and admittance control, contact-based interaction control",
                ],
              },
              {
                text: "Development of real-time control infrastructure",
                subList: [
                  "Design and implementation of motion planning libraries for real-time trajectory generation",
                  "Development of teleoperation algorithms",
                  "Maintaining motion accuracy between leader–follower systems and compensation for asynchronous sampling",
                ],
              },
            ],
          },
          {
            title: "Qualifications",
            list: [
              "Master’s degree or higher in Robotics, Control Engineering, or Mechatronics",
              "Experience in real-time control systems (C/C++, ROS2, RTOS, Python etc.)",
              "High-DOF robot control and sensor fusion experience",
              "Proficiency in kinematics, dynamics, and optimal control",
            ],
          },
          {
            title: "Preferred Qualifications",
            list: [
              "Hands-on experience in humanoid or manipulator control",
              "EtherCAT-based real-time control and safety logic implementation",
              "Experience with physics-based simulation environments (Gazebo, Isaac Sim, etc.)",
            ],
          },
          {
            title: "How to Apply",
            content:
              "Email: recruite@wirobotics.com\nDocuments: Resume, Portfolio (optional)\nDeadline: Open until filled",
          },
        ],
      },
      firmware: {
        title: "Communication · Firmware · Safety Engineer",
        type: "Full-Time",
        location: "Seoul",
        openings: "Until filled",
        sections: [
          {
            title: "Overview",
            content:
              "WIRobotics develops the integrated real-time communication, embedded firmware, and functional safety (FS) systems for humanoid robot. This position plays a key role in the EtherCAT-based network and safety architecture — ensuring humanoid robots operate safely in both home and industrial environments.",
          },
          {
            title: "Key Responsibilities",
            list: [
              "Real-Time Communication & Firmware Architecture",
              "Design and optimize communication systems based on EtherCAT, CAN, RS485, SPI, and FoE",
              "Develop distributed clock synchronization and real-time data streaming logic",
              "Implement embedded firmware (C/C++) for robot controllers, sensors, and servo drivers",
              "Functional Safety Design & Certification",
              "Design safety logic compliant with IEC 61508, ISO 13849, ISO 10218 standards",
              "Perform FMEA/FMEDA, risk analysis, and safety documentation",
              "Collaborate with certification and assessment agencies for product safety approval",
              "Hardware Integration & Protection Systems",
              "Design power, E-stop, and fail-safe circuits",
              "Develop EMI/EMC and ESD protection systems",
              "Implement safety protection logic across hardware and firmware layers",
              "System Integration & Validation",
              "Validate safety-critical interfaces between control and hardware systems",
              "Perform simulation and real-robot testing for safety verification",
              "Collaborate with mechanical, control, and AI teams for integrated system safety",
            ],
          },
          {
            title: "Qualifications",
            list: [
              "Bachelor’s degree or higher in Electrical, Control, or Robotics Engineering",
              "Embedded firmware development experience in C/C++ and RTOS environments",
              "Practical experience with industrial Fieldbus systems (EtherCAT, CANopen, RS485)",
              "Understanding and implementation experience of Functional Safety standards (IEC 61508, ISO 13849, ISO 10218)",
              "Debugging and integration experience across hardware and firmware layers",
            ],
          },
          {
            title: "Preferred Qualifications",
            list: [
              "Experience in real-time communication and safety architecture for robotics or automation",
              "Experience with international certification processes (UL, CE, KC, NRTL, Functional Safety)",
              "Linux real-time kernel experience (Xenomai / Preempt-RT)",
              "Experience with ASIL/SIL-level risk analysis and FSoE (EtherCAT Safety) implementation",
            ],
          },
          {
            title: "How to Apply",
            content:
              "Email: recruite@wirobotics.com\nDocuments: Resume, Portfolio (optional)\nDeadline: Open until filled",
          },
        ],
      },
    },
    careers: {
      title: "We’re looking for teammates to join our exciting journey —",
      titleAcc:
        "to redefine robotics, push boundaries, and revolutionize the world.",
      description1:
        "Robotics and AI, long evolving in parallel, are now colliding in a moment of Big Bang.",
      description2:
        "Our mission is bold, and the potential of our technology is limitless. We’re not looking for employees.",
      description3:
        "We’re looking for Builders, Thinkers, and Doers — people who dare to turn imagination into reality.",
      description4:
        "Join us in shaping the next era of robotics across mechanical design, electronics, control, software, and AI.",
      positions: {
        mechanicalDesign: "Robot Mechanical Design & Manufacturing Engineer",
        electronicsHardware: "Electrical Hardware Engineer",
        robotSoftware: "Software Engineer",
        robotAIEngineer1: "AI Engineer (Robot Learning)",
        robotAIEngineer2: "AI Engineer (Inference System)",
        robotControl: "Robot Control Engineer",
        firmware: "Communication · Firmware · Safety Engineer",
      },
      contactTitle: "Have another role in mind?",
      contactSubtitle: "Let us know what you could bring to the team.",
    },
  },
};

export function getTranslation(language, key) {
  const keys = key.split(".");
  let result = translations[language];
  for (const k of keys) {
    if (result && result[k] !== undefined) {
      result = result[k];
    } else {
      return key;
    }
  }
  return result;
}

export function useTranslation() {
  return { t: getTranslation, translations };
}

export default translations;
